module.exports = __webpack_public_path__ + "img/pipe-tutorial02.67d80c42.png";